<template>
  <div>
    <b-row>
      <b-col md="9">
        <iframe
          v-if="podcast.youtube_link && getYoutubeId(podcast.youtube_link)"
          :src="getEmbedUrl(podcast.youtube_link)"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          class="w-100 rounded-lg"
          style="aspect-ratio: 16 / 9;"
        />
        <p v-else class="text-center text-red-500">Video not available.</p>

        <div class="mt-1 flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <h2 class="fw-bold text-dark" style="font-weight: 700; color: #000;">
            {{ podcast.title }}
          </h2>
          <div class="d-flex justify-content-between align-items-center mt-2">
            <div class="text-sm text-gray-600">
              {{ podcast.total_view }} views • {{ formatDate(podcast.createdat) }}
            </div>
            <div class="d-flex align-items-center gap-4">
              <div class="icon-border" v-b-tooltip.hover.top="'Copy link'" @click="copyToClipboard">
                <feather-icon icon="Share2Icon" size="18" class="text-gray-500 cursor-pointer" />
              </div>
            </div>
          </div>
        </div>

        <b-card class="mt-3">
          <b-card-text>
            <b-badge
              v-for="(label, index) in podcast.label.split(',')"
              :key="index"
              pill
              variant="warning"
              class="mr-1"
            >
              {{ label.trim() }}
            </b-badge>
            <b-row class="mt-2">
              <b-col md="12" style="text-align: justify;">
                <div v-if="containsHtml(podcast.description)" v-html="podcast.description"></div>
                <div v-else>{{ podcast.description }}</div>
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>

        <b-card class="mt-3">
          <CommentSection :podcast-id="podcastId" :token="token" />
        </b-card>
      </b-col>

      <b-col md="3">
        <div v-if="podcast" class="related-videos">
          <ul class="related-list">
            <li v-for="video in visibleVideos" :key="video.id" class="related-item">
              <a :href="`/podcast/${video.id}`" class="thumb-link">
                <img
                  :src="`https://img.youtube.com/vi/${getYoutubeId(video.youtube_link)}/mqdefault.jpg`"
                  alt="Thumbnail"
                  class="thumb-img"
                />
              </a>
              <div class="video-info" style="width: 200px;">
                <a
                  :href="`/podcast/${video.id}`"
                  class="video-title text-truncate d-block"
                  :title="video.title"
                >
                  {{ video.title }}
                </a>
                <p class="video-meta">
                  {{ video.views }} views • {{ formatDate(video.createdat) }}
                </p>
              </div>
            </li>
          </ul>

          <div class="load-more-container" v-if="filteredVideos.length > 0">
            <button
              class="btn-load-more w-100"
              @click="toggleShowAll"
              :disabled="isLoadingMore"
            >
              <span v-if="isLoadingMore">Loading...</span>
              <span v-else>{{ showAll ? 'Show Less' : 'Load More' }}</span>
            </button>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
  <script>
  import { BBadge, BCard, BCardText, BCol, BRow, BTooltip, VBTooltip } from 'bootstrap-vue'
  import CommentSection from './CommentSection.vue'
  import Ripple from 'vue-ripple-directive'
  import { generateToken } from '@/auth/helperAuth'
  export default {
    components: {
      BRow,
      BCol,
      BCard,
      BCardText,
      BBadge,
      CommentSection,
      BTooltip,
      VBTooltip
    },
    data() {
      return {
        token:"",
        podcast: null,
        otherVideos: [],
        showAll: false,
        pagination: {
          skip: 0,
          limit: 6
        },
        isLoadingMore: false,
        podcastId: this.$route.params.id,
      }
    },
    directives: {
      Ripple,
      'b-tooltip': VBTooltip,
    },
    created() {
      const payload = {
        client: "product-catalog-fe",
        kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
        user: this.$store.getters['oauth/getActiveUser'].name,
        role: this.$store.getters['oauth/getActiveUser'].role,
      };
      this.token = generateToken(payload)
    },
    mounted() {
      const id = this.$route.params.id
      this.detailPodcast(id)
      this.addViewCount(id)
      this.fetchPodcast(this.pagination.skip, this.pagination.limit)
    },
    methods: {
      detailPodcast(id){
        this.$http
          .get(`${process.env.VUE_APP_API_HELPER_URL}/podcast/${id}`, {
            headers: {
              Authorization: this.token,
              Accept: 'application/json'
            }
          })
          .then(({ data }) => {
            this.podcast = data.data
          })
          .catch(err => {
            console.error('Failed to fetch podcast:', err)
          })
      },
      copyToClipboard() {
        const url = window.location.href;
        navigator.clipboard.writeText(url)
          .then(() => {
            this.$bvToast.toast('Podcast link copied!', {
              title: 'Success',
              variant: 'success',
              solid: true,
              autoHideDelay: 3000
            });
          })
          .catch(err => {
            console.error('Failed to copy: ', err);
            this.$bvToast.toast('Failed to copy link', {
              title: 'Error',
              variant: 'danger',
              solid: true,
              autoHideDelay: 3000
            });
          });
      },
      getYoutubeId(url) {
        const match = url.match(
          /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/
        )
        return match ? match[1] : null
      },
      getEmbedUrl(youtube_link) {
        const id = this.getYoutubeId(youtube_link);
        if (!id) return '';
        return `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1&showinfo=0&disablekb=1&autoplay=1`;
      },
      formatDate(dateString) {
        const published = new Date(dateString)
        const now = new Date()
        const diff = Math.floor((now - published) / (1000 * 60 * 60 * 24))

        if (diff === 0) return 'today'
        if (diff === 1) return '1 day ago'
        return `${diff} days ago`
      },
      fetchPodcast(skip, limit) {
        this.$http
          .get(`${process.env.VUE_APP_API_HELPER_URL}/podcast?skip=${skip}&limit=${limit}`, {
            headers: {
              Authorization: this.token,
              Accept: 'application/json'
            }
          })
          .then(({ data }) => {
            const newItems = data.data.map(item => ({
              id: item.id,
              title: item.title,
              youtube_link: item.youtube_link,
              description: item.description,
              views: item.total_view || 0,
              createdat: item.createdat,
              createdBy: item.createdby,
            }))
            this.otherVideos.push(...newItems)
          })
          .catch(err => {
            console.error('Failed to fetch podcast:', err)
          })
          .finally(() => {
            this.isLoadingMore = false;
          });
      },
      loadMore() {
        this.isLoadingMore = true;
        this.pagination.skip += this.pagination.limit;
        this.fetchPodcast(this.pagination.skip, this.pagination.limit);
        this.showAll = true;
      },
      addViewCount(id) {
        const requestData = {
          total_view: 1,
        }
        this.$http.put(`${process.env.VUE_APP_API_HELPER_URL}/podcast/${id}`, requestData, {
          withCredentials: true,
          headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
        })
          .then((resp) => {})
          .catch(error => {
            this.$notif('Error', `${error.data.message}`, 'error')
          })
      },
      toggleShowAll() {
        if (this.showAll) {
          this.showAll = false; // kembali ke tampilan 5 video
        } else {
          // jika belum semua video ditampilkan, fetch tambahan kalau perlu
          if (this.filteredVideos.length <= this.otherVideos.length) {
            this.pagination.skip += this.pagination.limit;
            this.fetchPodcast(this.pagination.skip, this.pagination.limit);
          }
          this.showAll = true; // tampilkan semua video
        }
      },
      containsHtml(content) {
        const pattern = /<\/?[a-z][\s\S]*>/i;
        return pattern.test(content);
      }
    },
    computed: {
      filteredVideos() {
        if (!this.podcast) return this.otherVideos;
        return this.otherVideos.filter(video => video.id !== this.podcast.id);
      },
      visibleVideos() {
        return this.showAll ? this.filteredVideos : this.filteredVideos.slice(0, 5);
      }
    },

  }
  </script>

  <style scoped>
    /* CSS */
    .related-list {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .related-videos {
      max-height: 100%;
      overflow-y: visible;
    }

    iframe,
    .main-left {
      display: block;
    }

    .related-item {
      display: flex;
      gap: 12px;
      margin-bottom: 16px;
      cursor: pointer;
    }

    .thumb-link {
      flex-shrink: 0;
      width: 120px;
      height: 68px;
      min-width: 120px;
      overflow: hidden;
      border-radius: 4px;
      background-color: #ddd;
      display: block;
    }

    .thumb-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }

    .thumb-link:hover .thumb-img {
      transform: scale(1.05);
    }

    .video-info {
      flex: 1;
      min-width: 0; 
    }

    .video-title {
      font-weight: 500;
      font-size: 14px;
      color: #030303;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 1.3;
      margin-bottom: 4px;
      text-decoration: none;
      cursor: pointer;
    }

    .video-title:hover {
      color: #cc0000; 
    }

    .video-meta {
      font-size: 12px;
      color: #606060;
      line-height: 1.3;
      user-select: none;
    }

    .load-more-container {
      text-align: center;
      margin-top: 10px;
    }

    .btn-load-more {
      background-color: #cc0000;
      border: none;
      padding: 8px 20px;
      color: white;
      font-weight: 500;
      font-size: 14px;
      border-radius: 4px;
      cursor: pointer;
      transition: background-color 0.2s ease;
    }

    .btn-load-more:hover {
      background-color: #b30000;
    }

    .icon-border {
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 4px;
      display: inline-flex;
      cursor: pointer;
      transition: border-color 0.2s;
      margin-right: 8px;
    }

    .icon-border:hover {
      border-color: #f87171;  
    }

    .icon-border:last-child {
      margin-right: 0;
    }

    /* Responsive */
    @media (max-width: 768px) {
      .related-item {
        gap: 8px;
      }
      .thumb-link {
        width: 100px;
        height: 56px;
        min-width: 100px;
      }
      .video-title {
        font-size: 13px;
      }
      .video-meta {
        font-size: 11px;
      }
    }

  </style>
